var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M6.4 25c0 5 2 9.6 5.3 13l.2.2 26.3-26.3c-3.4-3.4-8-5.5-13.2-5.5C14.7 6.4 6.4 14.7 6.4 25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0A611",
    d: "M11.7 38c-3.3-3.4-5.3-8-5.3-13C6.4 14.7 14.7 6.4 25 6.4c5.1 0 9.8 2.1 13.2 5.5L41 9c-4.1-4.1-9.8-6.6-16-6.6C12.5 2.4 2.4 12.5 2.4 25c0 6.1 2.4 11.6 6.3 15.7l.3.3 2.8-2.8c0-.1-.1-.1-.1-.2",
    className: "loading_svg__st1"
  })));
};
export default SvgLoading;